/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { dropdownItemOfintSchema } from './dropdownItemOfintSchema.ts';
import { optionalSelectOptionSchema } from './optionalSelectOptionSchema.ts';
import { z } from 'zod';

export const createMacroProjectSchema = z.object({
  name: z.coerce.string().min(1).max(500),
  client: z.lazy(() => dropdownItemOfintSchema),
  isVisible: z.boolean(),
  costCenter: z.lazy(() => optionalSelectOptionSchema).nullable(),
});
